import { render } from "./ConfigAutoTs.vue?vue&type=template&id=059b0e2d&ts=true"
import script from "./ConfigAutoTs.vue?vue&type=script&lang=ts"
export * from "./ConfigAutoTs.vue?vue&type=script&lang=ts"

import exportComponent from "/home/vsts/work/1/s/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__